import React from 'react';
import { Navbar } from 'react-bootstrap';
import logo from '../../assets/OneLineTransparent.gif';
import NavBar from './NavBar';
import userStore from '../../store/userStore';

/**UI component which handles if a user is logged in they get the navbar */
class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userLogged: userStore.userLoggedIn,
            show: false
        };
    }
    componentWillMount() {
        this.navSetter();
        userStore.on("User-Changes", this.navSetter);
    }
    componentWillUnmount() {
        userStore.removeListener("User-Changes", this.navSetter);
    }
    componentDidUpdate() {
        // if(!this.state.userLogged){
        //     this.navSetter();
        // }
    }
    navSetter = () => {
        this.setState({ userLogged: userStore.userLoggedIn });
    };
    hideModal = () => {
        this.setState({ show: false });
    };
    showModal = () => {
        this.setState({ show: true });
    };
    render() {

        return (
            // <Container>
            <div id="header" style={{ position: "fixed", zIndex: 100, width: "100%" }}>

                <Navbar bg="light" variant="light" expand="lg">
                    <Navbar.Brand href="#home">
                        <img src={logo} href="/" className="img " alt={this.props.title} height="52px" /> SharePoint Site Creator
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    {this.state.userLogged ?
                        // <span className="pull-right">
                        <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
                            <NavBar history={this.props.history} hide={this.hideModal} showModal={this.showModal} show={this.state.show} />
                        </Navbar.Collapse>
                        // </span>
                        : null}
                </Navbar>
            </div>

            // </Container>
        );
    }
}
export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js